import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import popupMessage from "../../../services/popupMessage";
import {
  Container,
  Card,
  Grid,
  Box,
  Typography,
  CardActions,
  Button,
  Breadcrumbs,
  Modal,
  CardMedia,
} from "@mui/material";

import { instanceToken } from "../../../utils/constant";

const styleR = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PopupMessage = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [message, setMessage] = useState({});
  const [openR, setOpenR] = useState(false);

  useEffect(() => {
    const fetchMessage = async () => {
      try {
        const res = await popupMessage.findOne(instanceToken.token, id);
        console.log("response is ======>", res, res?.data);
        setMessage(res?.data);
      } catch (error) {
        console.error(error);
        throw new Error(error);
      }
    };
    fetchMessage();
  }, [id]);

  const handleOpenR = () => setOpenR(true);
  const handleCloseR = () => setOpenR(false);
  const handleRemove = async () => {
    try {
      await popupMessage.remove(instanceToken.token, id);
      homeAlert("New post have been removed.", false);
      navigate("/popup-messages");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };
  // if (!message) {
  //   return <em>Loading...</em>;
  // }
  return (
    <>
      <div role="presentation">
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" to="/popup-messages">
            Popup Message
          </Link>
          <Typography color="text.primary">Popup (ID - {id})</Typography>
        </Breadcrumbs>
      </div>
      <Container
        maxWidth={false}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          mt: 2,
        }}
      >
        <Card
          sx={{
            minWidth: "80vw",
            minHeight: "60vh",
            display: "flex",
            flexDirection: "column",
            // gridTemplateColumns: "2fr 3fr",
          }}
        >
          <Box
            sx={{
              maxWidth: "40vw",
              justifyContent: "center",
              ml: 33,
              borderRadius: 2,
              boxShadow: 2,
            }}
          >
            <CardMedia
              component="img"
              height="320"
              image={`${message?.image_url}`}
            />
          </Box>
          <Box
            sx={{
              ml: 2,
              p: 2,
              // bgcolor: "#f7f7f5",
              borderRadius: 2,
            }}
          >
            {/* title Eng */}
            <Grid sx={{ m: 2 }} container spacing={2}>
              <Grid item xs={2}>
                <Typography variant="body2" color="text.secondary">
                  Title :
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body2" color="text.secondary">
                  {message?.title !== "undefined" ? message?.title : "#"}
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <CardActions sx={{ gridColumn: "1/3", justifyContent: "end" }}>
            <Button
              sx={{ m: "1rem" }}
              variant="contained"
              color="error"
              onClick={handleOpenR}
            >
              Remove
            </Button>
            <Button
              size="small"
              variant="contained"
              component={Link}
              to={`/popup-messages/update/${message?.id}`}
            >
              Edit
            </Button>
          </CardActions>
        </Card>
      </Container>
      <Modal
        keepMounted
        open={openR}
        onClose={handleCloseR}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={styleR}>
          <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
            Confirmation
          </Typography>
          <Typography id="keep-mounted-modal-description" sx={{ mt: 2 }}>
            Are you sure want to remove it?
          </Typography>
          <Box sx={{ textAlign: "right", mt: 2 }}>
            <Button color="secondary" onClick={handleCloseR}>
              Cancel
            </Button>
            <Button onClick={handleRemove}>Confirm</Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PopupMessage;
